function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_744",
  "data-name": "Grupo 744",
  transform: "translate(-436.927 -298.454)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_609",
  "data-name": "Grupo 609",
  transform: "translate(531.085 298.454)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_606",
  "data-name": "Grupo 606",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_605",
  "data-name": "Grupo 605"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_390",
  "data-name": "Caminho 390",
  d: "M832.665,331.368v7.649h-7.649V302.958h13.112a14.2,14.2,0,1,1,0,28.41Zm0-20.761v13.112h5.463a6.556,6.556,0,0,0,0-13.112Z",
  transform: "translate(-825.016 -301.865)",
  fill: "#1d3054"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_391",
  "data-name": "Caminho 391",
  d: "M988.273,304.049a19.151,19.151,0,1,1-13.506-5.595A18.405,18.405,0,0,1,988.273,304.049ZM974.768,306.1a11.491,11.491,0,1,0,8.086,3.366A11.076,11.076,0,0,0,974.768,306.1Z",
  transform: "translate(-923.936 -298.454)",
  fill: "#1d3054"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_392",
  "data-name": "Caminho 392",
  d: "M1140.274,339.017V302.958h14.774a18.029,18.029,0,0,1,0,36.059Zm7.649-28.41v20.761h7.125a10.381,10.381,0,0,0,0-20.761Z",
  transform: "translate(-1063.786 -301.865)",
  fill: "#1d3054"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_393",
  "data-name": "Caminho 393",
  d: "M1326.447,302.958v7.649h-16.39v6.556h13.113v7.649h-13.113v6.556h16.39v7.649h-24.039V302.958Z",
  transform: "translate(-1186.583 -301.865)",
  fill: "#1d3054"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_608",
  "data-name": "Grupo 608",
  transform: "translate(23.764 38.166)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_607",
  "data-name": "Grupo 607"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_394",
  "data-name": "Caminho 394",
  d: "M940.535,497.74,927.99,480.431v27.8h-5.026V470.422h4.021l15.429,21.286,15.341-21.286h4.109v37.808h-5.026V480.344l-12.544,17.4Z",
  transform: "translate(-922.964 -469.329)",
  fill: "#b61817"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_395",
  "data-name": "Caminho 395",
  d: "M1143.1,485.893a20,20,0,1,1-5.857-14.118A19.292,19.292,0,0,1,1143.1,485.893Zm-1.792,2.77C1140.771,491.035,1141.7,487.027,1141.311,488.664Zm-18.183-17.718a14.989,14.989,0,0,0-10.62,25.569,14.943,14.943,0,0,0,6.3,3.788,14.71,14.71,0,0,0,4.316.583,14.97,14.97,0,1,0,0-29.94Z",
  transform: "translate(-1062.169 -465.919)",
  fill: "#b61817"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_396",
  "data-name": "Caminho 396",
  d: "M1304.94,499.051a14.038,14.038,0,0,1-1.836.328,16.655,16.655,0,0,1-1.88.109h-8.435v8.742h-5.027V470.422h13.462A14.526,14.526,0,0,1,1311.5,495.2q-.481.481-.961.918a10.256,10.256,0,0,1-1.049.83q.743,1.531,1.573,3.147t1.7,3.235q.611,1.224,1.268,2.535t1.224,2.36h-5.638Zm-12.151-23.6v19.013h8.435a9.105,9.105,0,0,0,6.688-2.754,9.229,9.229,0,0,0,2.8-6.775,9.551,9.551,0,0,0-9.485-9.485Zm17.134,22.772a.73.73,0,0,1-.088-.219A.73.73,0,0,0,1309.923,498.22Z",
  transform: "translate(-1204.435 -469.329)",
  fill: "#b61817"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_397",
  "data-name": "Caminho 397",
  d: "M1439.718,502.766h-22.99l-2.579,5.464h-5.507l17.658-37.808h3.846l17.7,37.808h-5.55Zm-2.316-5.026-9.179-19.538-9.178,19.538Z",
  transform: "translate(-1298.227 -469.329)",
  fill: "#b61817"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_398",
  "data-name": "Caminho 398",
  d: "M1597.679,499.051a14.036,14.036,0,0,1-1.835.328,16.659,16.659,0,0,1-1.88.109h-8.436v8.742H1580.5V470.422h13.462a14.526,14.526,0,0,1,10.271,24.783q-.48.481-.962.918a10.229,10.229,0,0,1-1.048.83q.742,1.531,1.573,3.147t1.7,3.235l1.267,2.535q.656,1.311,1.224,2.36h-5.638Zm-12.151-23.6v19.013h8.436a9.1,9.1,0,0,0,6.687-2.754,9.228,9.228,0,0,0,2.8-6.775,9.552,9.552,0,0,0-9.485-9.485Zm17.134,22.772a.743.743,0,0,1-.088-.219A.743.743,0,0,0,1602.662,498.22Z",
  transform: "translate(-1430.308 -469.329)",
  fill: "#b61817"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_611",
  "data-name": "Grupo 611",
  transform: "translate(436.927 299.594)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_610",
  "data-name": "Grupo 610",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_399",
  "data-name": "Caminho 399",
  d: "M618.988,303.492a6.474,6.474,0,1,1-6.679,6.47,6.579,6.579,0,0,1,6.679-6.47m-3.8,68.153,0-39.636-30.951-22.217a3.606,3.606,0,0,1-.79-5.148,3.884,3.884,0,0,1,5.317-.765L621.252,327.2a3.632,3.632,0,0,1,1.534,3.1v45.037a3.739,3.739,0,0,1-3.8,3.678c0,.013-15.656.017-31.645.017h0a3.7,3.7,0,1,1,0-7.387h27.85Z",
  transform: "translate(-547.334 -303.155)",
  fill: "#b61817",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_400",
  "data-name": "Caminho 400",
  d: "M458.17,315.594l-16.822,12.077a3.639,3.639,0,0,0-1.535,2.955l-.016,45.181a3.755,3.755,0,0,0,3.813,3.692l15.588,0a3.7,3.7,0,1,0,0-7.386H447.406V332.482L462.7,321.507a3.6,3.6,0,0,0,.788-5.148,3.88,3.88,0,0,0-5.315-.765m-14.56,1.122a6.474,6.474,0,1,0-6.682-6.471A6.578,6.578,0,0,0,443.609,316.716Z",
  transform: "translate(-436.927 -303.624)",
  fill: "#1d3054",
  fillRule: "evenodd"
}))));

function SvgPodemorarfull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 296.09,
    height: 78.158,
    viewBox: "0 0 296.09 78.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodemorarfull);
export default __webpack_public_path__ + "static/media/podemorarfull.e36f5dde.svg";
export { ForwardRef as ReactComponent };